import React from 'react';
import { Switch, Route } from 'react-router-dom';
import WaitingList from '../../pages/waitingList/list/list.js';
import WaitingListForm from '../../pages/waitingList/details/waitingListForm.js';
import PageError from '../../pages/error/pageError';
import { ManagerContextProvider } from '../../pages/manager/components/context';

export default function WaitingListRouter({ organization, path }) {
    return (
        <ManagerContextProvider>
            <Switch>
                <Route
                    exact
                    path={[`${path}/`, `${path}`]}
                    render={({ match, history }) => {
                        return <WaitingList organization={organization} />;
                    }}
                />
                <Route
                    exact
                    path={`${path}/new`}
                    render={({ match, history }) => {
                        return <WaitingListForm organization={organization} />;
                    }}
                />
                <Route
                    exact
                    path={`${path}/:waitingListId`}
                    render={({ match, history }) => {
                        return <WaitingListForm organization={organization} waitingListId={match.params.waitingListId} />;
                    }}
                />
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
            </Switch>
        </ManagerContextProvider>
    );
}
